export var HistoricalPriceStuctureTrendDirection;
(function (HistoricalPriceStuctureTrendDirection) {
    HistoricalPriceStuctureTrendDirection["uptrend"] = "uptrend";
    HistoricalPriceStuctureTrendDirection["downtrend"] = "downtrend";
    HistoricalPriceStuctureTrendDirection["sideways"] = "sideways";
})(HistoricalPriceStuctureTrendDirection || (HistoricalPriceStuctureTrendDirection = {}));
export var HistoricalPriceStuctureTrendSize;
(function (HistoricalPriceStuctureTrendSize) {
    HistoricalPriceStuctureTrendSize["verySmall"] = "verySmall";
    HistoricalPriceStuctureTrendSize["small"] = "small";
    HistoricalPriceStuctureTrendSize["medium"] = "medium";
    HistoricalPriceStuctureTrendSize["large"] = "large";
    HistoricalPriceStuctureTrendSize["veryLarge"] = "veryLarge";
})(HistoricalPriceStuctureTrendSize || (HistoricalPriceStuctureTrendSize = {}));
export var HistoricalPriceStructureTermSizes;
(function (HistoricalPriceStructureTermSizes) {
    HistoricalPriceStructureTermSizes["veryLong"] = "veryLong";
    HistoricalPriceStructureTermSizes["long"] = "long";
    HistoricalPriceStructureTermSizes["longer"] = "longer";
    HistoricalPriceStructureTermSizes["medium"] = "medium";
    HistoricalPriceStructureTermSizes["short"] = "short";
    HistoricalPriceStructureTermSizes["veryShort"] = "veryShort";
    HistoricalPriceStructureTermSizes["immediate"] = "immediate";
})(HistoricalPriceStructureTermSizes || (HistoricalPriceStructureTermSizes = {}));
//# sourceMappingURL=HistoricalPriceStructure.js.map